import { APP_FLAVOR_CONFIGS } from "constants/appFlavors";
import { sendMessageToRNWebView } from "./appIFrameWebview";
import { enqueueSnackbar } from "notistack";

const getAppFlavorConfig = () => {
  const isRNWebView = !!window?.isRNWebView;
  const growsariAppName = window?.growsariAppName || "";

  return {
    isRNWebView,
    growsariAppName,
  };
};

const isKasaAgentApp = () => {
  const growsariAppName = window?.growsariAppName || "";
  const isRNWebView = !!window?.isRNWebView;

  return growsariAppName === APP_FLAVOR_CONFIGS.KASA.id && isRNWebView;
};

const logOutAppFlavor = () => {
  if (isKasaAgentApp()) {
    enqueueSnackbar({
      message: "User Logged Out",
      variant: "warning",
    });
    sendMessageToRNWebView(JSON.stringify({ message: "LOGOUT_FROM_IN_WEBAPP" }));
  }
};

const isSignUpAllowed = () => {
  return !isKasaAgentApp();
};

const isLoginAllowed = () => {
  return !isKasaAgentApp();
};

const isMessageSourceFromKASA = (source: string) => {
  return source === APP_FLAVOR_CONFIGS.KASA.id;
};

const kasaAppAPIErrorLogger = (errorLocation: string, errorMessage: string) => {
  if (isKasaAgentApp()) {
    enqueueSnackbar({
      message: `${errorLocation}: ${errorMessage}`,
      variant: "error",
    });
  }
};

const showLoadProductsFromLocalDB = () => {
  return isKasaAgentApp() && !!window.kasaAppVersion && window.kasaAppVersion >= "5.2.2";
};

export {
  isKasaAgentApp,
  getAppFlavorConfig,
  logOutAppFlavor,
  isSignUpAllowed,
  isLoginAllowed,
  isMessageSourceFromKASA,
  kasaAppAPIErrorLogger,
  showLoadProductsFromLocalDB,
};
